<template>

  <!-- Completed (COMPLETED) -->
  <route-list-data-table
      title="Completed"
      defaultSortField="completed_at"
      defaultSortOrder="dsc"
      :myRoutes="true"
      :headers="headers"
      :status="status"
      :assocs="assocs"
      routeClickGoTo="route-info" />

</template>

<script>
import RouteListDataTable from '@/components/routes/RouteListDataTable'

export default {
  name: 'DeliveryListCompletedPage',

  components: {
    RouteListDataTable
  },

  data () {
    return {
      headers: [
        { text: 'Name', align: 'start', value: 'name', width: '180px' },
        { text: 'Orders', sortable: false, value: 'orders', width: '170px' },
        { text: 'Actions', sortable: false, align: 'center', value: 'id' },
        { text: 'Delivery Date', value: 'delivery_date' },
        { text: 'Driver', value: 'driver_user_id' },
        { text: 'Vehicle', value: 'vehicle_id' },
        { text: 'Completed', value: 'completed_at' },
        { text: 'Status', value: 'route_status' }
      ],
      status: ['COMPLETED'],
      assocs: 'orders,driver,vehicle'
    }
  }
}
</script>

<style scoped>
</style>
